export default function splitByLetter(str) {
    if(!str) return [];
    return str.split("")
}